
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter-features",
      function () {
        return require("private-next-pages/converter-features.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter-features"])
      });
    }
  